import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import {KeyCodes} from "../models";

@Directive({
    selector: "[appShortcutKey]",
    standalone: false
})
export class ShortcutKeyDirective {
    keyCodes = KeyCodes;
    IPKeycode: number;
    altKey: boolean;
    ctrlKey: boolean;
    constructor(private _el: ElementRef) {}


    @Input()
    set AltKey(ri: string) {
        if (ri) {
            this.altKey = true;
            this.IPKeycode = this.keyCodes[ri.toLowerCase()];
        }
    }

    @Input()
    set CtrlKey(ri: string) {
        if (ri) {
            this.ctrlKey = true;
            this.IPKeycode = this.keyCodes[ri.toLowerCase()];
        }
    }


    @Input()
    set InputKey(ri: string) {
        this.IPKeycode = this.keyCodes[ri.toLowerCase()];
    }

    @HostListener("window:keydown", ["$event"])
    keyEventAlt(event: KeyboardEvent) {
        const activeElement = document.activeElement as HTMLElement;
        const hostContainer = this._el?.nativeElement?.closest?.("[role='dialog'], .modal, ngb-modal-window");
        const activeInSameContainer = hostContainer && activeElement
            ? hostContainer.contains(activeElement)
            : true; // preserve old behavior when not inside a dialog

        // Block plain-key shortcuts only when focus is on a text-like field inside the same dialog/popup.
        const isBlockingField = (() => {
            if (!activeElement || !activeInSameContainer) {
                return false;
            }
            if (activeElement.tagName === "TEXTAREA" || activeElement.tagName === "SELECT") {
                return true;
            }
            if (activeElement.isContentEditable || activeElement.getAttribute("contenteditable") === "true") {
                return true;
            }
            if (activeElement.tagName === "INPUT") {
                const type = (activeElement as HTMLInputElement).type?.toLowerCase() || "text";
                // Allow shortcuts when focus is on non-text inputs like radio/checkbox.
                return ["text", "password", "email", "number", "search", "tel", "url"].includes(type);
            }
            return false;
        })();
        if (this.altKey && (event.altKey || event.keyCode === 18)) {
            if (event.which === this.IPKeycode) {
                this.clickEvent(event);
            }
        } else if (this.ctrlKey && event.ctrlKey) {
            if (event.which === this.IPKeycode) {
                this.clickEvent(event);
            }
        } else if (!this.ctrlKey && !this.altKey && !event.ctrlKey && !event.altKey) {
            // Don't trigger plain key shortcuts when user is typing in blocking fields
            if (isBlockingField) {
                return;
            }
            if (event.which === this.IPKeycode) {
                this.clickEvent(event);
            }
        }
    }

    clickEvent(event) {
        const targetElem = document.elementFromPoint(
            Math.ceil(this._el.nativeElement.getBoundingClientRect().left + 2),
            Math.ceil(this._el.nativeElement.getBoundingClientRect().top) + 2);
        if (targetElem && targetElem.isSameNode(this._el.nativeElement)) {
            this._el.nativeElement.click();
            event.preventDefault();
            event.stopPropagation();
        }
    }
}
